import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import Button from "../../components/Button";
import Title from "../../components/Title";
import { Card } from "./Card";
import { DataPersonal } from "./DataPersonal";
import "./index.scss";
import { Plans } from "./Plans";
import { Validating } from "./StatusPages";
import { VerefyData } from "./VerefyData";

export type IPages = "Plans" | "Card" | "DataPersonal" | "VerefyData" | "Validating" | "Error" | "Success";
export type IPlan = "Month" | "Year";

export type ICardData = {
  numberCard: string;
  nameCard: string;
  monthCard: string;
  yearCard: string;
  ccvCard: string;
};

export type IDataPersonal = {
  name: string;
  email: string;
  phone: string;
  cpfCnpj: string;
  postalCode: string;
  street?: string;
  addressNumber?: string | number;
  complement?: string | number | undefined;
  district?: string;
  city?: string;
  state?: string;
};

export type IDataOptional = {
  street?: string;
  district?: string;
  city?: string;
  state?: string;
};

export const Payments = () => {
  const [page, setPage] = useState<IPages>("Plans");
  const [plan, setPlan] = useState<IPlan>();

  const [cardData, setCardData] = useState<ICardData>({
    numberCard: undefined,
    nameCard: undefined,
    monthCard: undefined,
    yearCard: undefined,
    ccvCard: undefined,
  });

  const [dataPersonal, setDataPersonal] = useState<IDataPersonal>({
    name: undefined,
    email: undefined,
    phone: undefined,
    cpfCnpj: undefined,
    postalCode: undefined,
    addressNumber: undefined,
    complement: undefined,
  });

  const [dataOptional, setDataOptional] = useState<{ street: string; district: string; city: string; state: string }>();

  const isPageStatus = page === "Validating" || page === "Error" || page === "Success";

  const isCard = page === "Card" || isPageStatus;

  return (
    <>
      <div className="container text-1.4rem text-textPrimary font-familyPoppins">
        {!isPageStatus && <Title title="Pagamentos" />}
        {page === "Plans" && <Plans setPlan={setPlan} setPage={setPage} />}
        {page === "DataPersonal" && (
          <DataPersonal
            setPage={setPage}
            dataPersonal={dataPersonal}
            setDataPersonal={setDataPersonal}
            dataOptional={dataOptional}
            setDataOptional={setDataOptional}
          />
        )}
        {page === "VerefyData" && (
          <VerefyData plan={plan} setPlan={setPlan} setPage={setPage} dataPersonal={dataPersonal} dataOptional={dataOptional} />
        )}
        {isCard && <Card page={page} setPage={setPage} cardData={cardData} setCardData={setCardData} plan={plan} dataPersonal={dataPersonal} />}
      </div>
    </>
  );
};
